import * as apiPayments from '@/network/api/payments/payments.api.js'
import * as apiFavorites from '@/network/api/favorites.api.js'
import * as frequentsApi from '@/network/api/frequents.api.js'

/** requests all payments operators
@payload { Object }
@return { promise } - payments operators request
*/
export const paymentsOperatorsFetch = async (context, payload) => {
    if (context.state.paymentsOperatorsList.length) return
    const res = await apiPayments.getPaymentsOperators(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_OPERATORS_LIST', data)
    }
    return res
}

/** requests payments history list
@payload { Object }
@return { promise } -  payments history list request
*/
export const paymentsListFetch = async (context, payload) => {
    const res = await apiPayments.getPaymentsList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PAYMENTS_LIST', data)
    }
    return res
}

/** requests favorites list
@payload { Object }
@return { promise } -  favorites list request
*/
export const favoritesListFetch = async (context, payload) => {
    const res = await apiFavorites.getFavoritesList(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_FAVORITES_LIST', { pageNumber: payload.pageNumber, data: data })
    }
    return res
}

/** requests favorites tabs
@payload { Object }
@return { promise } - favorites tabs request
*/
export const favoritesTabsFetch = async (context, payload) => {
    const res = await apiFavorites.getFavoritesTabs(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_FAVORITES_TABS', data)
    }
    return res
}

/** requests payment detail
@payload { Object }
@return { promise } -  payments detail request
*/
export const paymentDetailFetch = async (context, payload) => {
    const res = await apiPayments.getPaymentDetail(payload)
    if (res) {
        const data = res.data.data
        context.commit('SAVE_PAYMENT_DETAIL', data)
    }
    return res
}

/** requests frequent operations
@return { promise } - frequent operations response
*/
export const requestFrequentOperations = async (context, payload) => {
    const res = await frequentsApi.getFrequentOperations(payload)
    if (res) context.commit('SAVE_FREQUENT_OPERATIONS', res.data.cards)
    return res
}

/** requests Payment Detail
@return { promise } -  payment detail detail
*/
export const requestPaymentsDetail = async (context, payload) => {
    const res = await apiPayments.getPaymentDetail(payload)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
/** Clear Payment Services feature states
@return { promise }
*/
export const clearPaymentsServicesStates = async (context, payload) => {
    context.commit('CLEAR_PAYMENTS_SERVICES_STATE')
}
